import React, { FC, SyntheticEvent } from "react";
import { COLOR_PRIMARY_MAIN } from "shared/theme/colors";
import { StyledTab, StyledTabs } from "./styled";
import { Tab, TagsAndMetadataTabs } from "./types";
import { getTabProps } from "./utils";

export const tabs: Tab[] = [
  { id: TagsAndMetadataTabs.Tags, label: "Service Tags" },
  { id: TagsAndMetadataTabs.ThemeTags, label: "Theme Tags" },
  { id: TagsAndMetadataTabs.Metadata, label: "Metadata Tags" },
];

type TabsProps = {
  selectedTab: TagsAndMetadataTabs;
  setSelectedTab: (arg: TagsAndMetadataTabs) => void;
};

const Tabs: FC<TabsProps> = ({ selectedTab, setSelectedTab }) => {
  const handleTabChange = (_: SyntheticEvent, newTab: TagsAndMetadataTabs) => {
    setSelectedTab(newTab);
  };

  return (
    <StyledTabs
      value={selectedTab}
      onChange={handleTabChange}
      TabIndicatorProps={{
        style: {
          backgroundColor: COLOR_PRIMARY_MAIN,
          height: 2,
        },
      }}
    >
      <StyledTab
        {...getTabProps(TagsAndMetadataTabs.Tags)}
        value={TagsAndMetadataTabs.Tags}
        disableRipple
        label="Service Tags"
      />
      <StyledTab
        {...getTabProps(TagsAndMetadataTabs.ThemeTags)}
        value={TagsAndMetadataTabs.ThemeTags}
        disableRipple
        label="Theme Tags"
      />
      <StyledTab
        {...getTabProps(TagsAndMetadataTabs.Metadata)}
        value={TagsAndMetadataTabs.Metadata}
        disableRipple
        label="Metadata Tags"
      />
    </StyledTabs>
  );
};

export default Tabs;
